<template>
  <div class="box">
    <div class="box-header d-flex align-center justify-content-between">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> Resultado atual

        <div class="resultado-toggle ml-3">
          <button
            type="button"
            class="resultado-toggle-btn"
            :class="{ active: tipoResultado === 'quadrimestral' }"
            @click="$emit('changeTipoResultado', 'quadrimestral')"
          >
            Quadrimestre
          </button>
          <button
            type="button"
            class="resultado-toggle-btn"
            :class="{ active: tipoResultado === 'mensal' }"
            @click="$emit('changeTipoResultado', 'mensal')"
          >
            Mês
          </button>
        </div>
      </h4>
      <button class="btn btn-simulador" @click="abrirSimulador">
        Simulador
      </button>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>
              Numerador
              <span
                v-b-tooltip.hover
                title="Total de procedimentos do tipo Tratamento Restaurador Atraumático"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Denominador
              <span
                v-b-tooltip.hover
                title="Total de procedimentos restauradores"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              {{ tipoResultado == 'quadrimestral' ? 'Média' : 'Pontuação' }}
              <span
                v-b-tooltip.hover
                :title="
                  tipoResultado == 'quadrimestral'
                    ? 'Média dos resultados das pontuações no indicador acumulado no quadrimestre até o mês atual.'
                    : 'Numerador / Denominador * 100'
                "
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Classificação
              <!-- <span
                v-b-tooltip.hover
                title="Regular: <= 3;
                        Suficiente: > 3 e <= 6;
                        Bom: > 6 e <= 8;
                        Ótimo: > 8"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span> -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $store.state.cidade }}</td>
            <td class="text-center font-weight-bold">
              <loader :value="municipio.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="municipio.denominador"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="municipio.resultado"
                :loading="loading"
                :isPercentage="tipoResultado == 'quadrimestral' ? false : true"
              ></loader>
            </td>
            <td
              :class="getColorClassificacao(municipio.classificacao)"
              class="font-weight-bold"
            >
              <TextoClassificacaoIndicador
                :loading="loading"
                :classificacao="municipio.classificacao"
                :idIndicador="41"
                :resultado="municipio.resultado"
              />
            </td>
          </tr>
          <tr v-if="selectedEquipe != ''">
            <td>{{ selectedEquipe != '' ? selectedEquipe.no_equipe : '-' }}</td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe.denominador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="equipe.resultado"
                :loading="loading"
                :isPercentage="tipoResultado == 'quadrimestral' ? false : true"
              ></loader>
            </td>
            <td
              :class="getColorClassificacao(equipe.classificacao)"
              class="font-weight-bold"
            >
              <TextoClassificacaoIndicador
                :loading="loading"
                :classificacao="equipe.classificacao"
                :idIndicador="41"
                :resultado="equipe.resultado"
              />
            </td>
          </tr>
          <tr v-if="selectedMicroArea != ''">
            <td>
              {{
                selectedMicroArea != '' ? 'MICROÁREA ' + selectedMicroArea : '-'
              }}
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="micro_area.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="micro_area.denominador"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="micro_area.resultado"
                :loading="loading"
                :isPercentage="tipoResultado == 'quadrimestral' ? false : true"
              ></loader>
            </td>
            <td
              :class="getColorClassificacao(micro_area.classificacao)"
              class="font-weight-bold"
            >
              <TextoClassificacaoIndicador
                :loading="loading"
                :classificacao="micro_area.classificacao"
                :idIndicador="41"
                :resultado="micro_area.resultado"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <FonteSincronizadorC />
    </div>
    <SimuladorOdontoModal
      ref="simulador"
      modal-id="simulador-tra-modal"
      :dadosPercentualMunicipio="municipio"
      :dadosPercentualEquipe="equipe"
      :dadosPercentualMicroArea="micro_area"
      :selectedEquipe="selectedEquipe"
      :selectedMicroArea="selectedMicroArea"
    />
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import SimuladorOdontoModal from './SimuladorOdontoModal.vue'
import TextoClassificacaoIndicador from '@/components/utils/TextoClassificacaoIndicador'

export default {
  components: {
    Loader,
    SimuladorOdontoModal,
    TextoClassificacaoIndicador,
  },
  props: {
    disabledSelectResultado: {
      type: Boolean,
      default: false,
    },
    resetarSelectTabelaResultado: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    municipio: {
      type: Object,
      default: () => {},
    },
    equipe: {
      type: Object,
      default: () => {},
    },
    acs: {
      type: Object,
      default: () => {},
    },
    micro_area: {
      type: Object,
      default: () => {},
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: [String],
      default: '',
    },
    tipoResultado: {
      type: String,
      default: 'quadrimestral',
    },
  },
  data() {
    return {
      tituloTabela: '',
    }
  },
  mounted() {},
  watch: {},
  methods: {
    getColorClassificacao(classificacao) {
      switch (classificacao) {
        case 'Ótimo':
          return 'blue'
          break
        case 'Bom':
          return 'green'
          break
        case 'Suficiente':
          return 'orange'
          break
        case 'Regular':
          return 'red'
          break
        default:
          break
      }
    },

    abrirSimulador() {
      this.$refs.simulador.open()
    },
  },
}
</script>

<style lang="scss" src="../../styles.scss" scoped></style>
